export default __webpack_public_path__ + "static/media/file-a-claim.7f374f93.png";